import { NavLink } from 'react-router-dom';
import { Home, CalendarDays, PlusCircle, Trophy, User } from 'lucide-react';

const tabs = [
  { to: '/', label: 'Home', icon: Home, end: true, testid: 'tab-home' },
  { to: '/events', label: 'Events', icon: CalendarDays, testid: 'tab-events' },
  { to: '/create', label: 'Create', icon: PlusCircle, testid: 'tab-create' },
  { to: '/leaderboard', label: 'Leaderboard', icon: Trophy, testid: 'tab-leaderboard' },
  { to: '/profile', label: 'Profile', icon: User, testid: 'tab-profile' },
];

export function BottomTabs() {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 bg-background/95 backdrop-blur border-t border-border"
      data-testid="bottom-tabs"
    >
      <ul className="grid grid-cols-5">
        {tabs.map((t) => (
          <li key={t.to}>
            <NavLink
              end={t.end}
              to={t.to}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-widest font-semibold transition-colors ${
                  isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <t.icon className={`h-5 w-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
                  <span>{t.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
